// @flow

import { observer } from "mobx-react";
import React from "react";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import AppearanceStore from "app/stores/AppearanceStore";

import TimelineItem from "app/models/TimelineItem";
import type { Props as TimelineCardProps } from "app/components/TimelineCard/TimelineCard";
import TimelineCard from "app/components/TimelineCard/TimelineCard";
import TimelineConversation from "app/components/TimelineConversation/TimelineConversation";
import VideoProgress from "app/components/VideoProgress/VideoProgress";
import User from "app/models/User";

import "./TimelineCardSwitcher.scss";

type Props = TimelineCardProps & {
    item: ?TimelineItem,
    onExpand: Function,
    progress: number,
    serverTime: any,
    user: ?User
};

@observer
export default class TimelineCardSwitcher extends React.Component<Props> {
    lastItem: ?TimelineItem;

    getModifier() {
        const item = this.props.item;
        if (item && this.lastItem) return "current-and-last";
        if (item) return "current-only";
        if (this.lastItem) return "last-only";

        return "empty";
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.item === nextProps.item) {
            this.lastItem = null;
        } else {
            this.lastItem = this.props.item;
        }
    }

    render() {
        const modifier = this.getModifier();
        const empty = modifier === "empty";
        const effect = GlobalSettingsStore.cardSwitcherEffect;

        const classes = [
            "TimelineCardSwitcher",
            `TimelineCardSwitcher--${modifier}`,
            `TimelineCardSwitcher--${effect}`
        ];
        if (this.props.wizard && !empty)
            classes.push("TimelineCardSwitcher--wizard");

        const item = this.props.item;

        return (
            <div className={classes.join(" ")}>
                {this.renderProgress()}

                {/*
                  * @TODO if a video/audio is still playing and another is selected,
                  * they play simultaneosly
                  * The first to stop also stops the other
                  * This is caused by TimelineItemStore.isExpanded being read by both
                  * 
                  * lastItem is here for easy animation/transition

                    {this.renderItem(this.lastItem, "last")}
                */}
                {this.renderItem(item, "current")}

                {!item &&
                    (AppearanceStore.embed || AppearanceStore.isMobile) &&
                    this.renderBlankItem()}
            </div>
        );
    }

    renderProgress() {
        const item = this.props.item;
        if (this.props.wizard || !item) return null;

        const progress = Math.max(0, this.props.progress - item.start_time);
        const duration = item.duration;

        return <VideoProgress duration={duration} progress={progress} />;
    }

    renderItem(item: ?TimelineItem, type: string) {
        if (!item) return null;
        const props = { ...this.props, item };

        return (
            <div
                key={item.key}
                className={`TimelineCardSwitcher__item TimelineCardSwitcher__item--${type}`}
            >
                <div
                    className="TimelineCardSwitcher__item-background"
                    onClick={this.props.onCancelWizard}
                />
                {this.renderConversation(item)}
                {/* $FlowFixMe */}
                {<TimelineCard {...props} />}
            </div>
        );
    }

    renderBlankItem() {
        return (
            <div className="TimelineCardSwitcher__item">
                <div className="TimelineCard" style={{ height: "132px" }}>
                    <div className="TimelineCard__content" />
                </div>
            </div>
        );
    }

    renderConversation(item: TimelineItem) {
        if (this.props.editable || !this.props.item) return null;

        return (
            <div className="TimelineCardSwitcher__conversation">
                <TimelineConversation
                    userId={this.props.userId}
                    user={this.props.user}
                    comments={item.comments}
                    onDelete={this.props.onDeleteComment}
                    onComment={this.props.onComment}
                    serverTime={this.props.serverTime}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardSwitcher/TimelineCardSwitcher.js